import React, { Component} from "react";
import Card from "components/Card/StatsCard";

class SummaCard extends Component {
    render() {
    return <Card statsIconText={this.props.stats} bigIcon={this.props.icon} statsText={this.props.title} statsValue={this.props.value} />;
    }
}
export default SummaCard;